import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Toastr } from "@revvsales/components";

// Actions Imports
import {
  approvalStatusCheck,
  approveRejectDoc,
  fetchAndUpdateDocMeta,
} from "../../../../actions/DocumentActions";

import { EVENTS } from "../../../../constants";
import { AmplitudeUtils } from "../../../../utils";

// Declarations
const CONFIRMATION_TEXT = {
  approve: {
    title: "Approve Document",
    txt:
      "Click Approve if you want to approve the document. Once approved, your account executive will be able to send the document to your client. Click Cancel if you want to cancel the operation.",
    btnTxt: "Approve",
  },
  reject: {
    title: "Reject Document",
    txt:
      "You are rejecting this document. Enter your comments or reason for rejecting the document.",
    btnTxt: "Reject",
  },
};

class WorkFlowApproveReject extends Component {
  state = { comment: "", errMsg: "", isSaving: false };

  _onCommentChange = e => {
    this.setState({ comment: e.target.value });
  };

  _onSubmitBtnClick = () => {
    // In case of reject, adding comments is mandatory
    if (this.props.view === "reject" && !this.state.comment) {
      return this.setState({ errMsg: "Enter your comments." });
    }

    this.setState({ isSaving: true });
    return this.props
      .approveRejectDoc(
        this.props.docID,
        { user_comment: this.state.comment },
        this.props.view === "approve",
      )
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: `Document ${this.props.view}${
            this.props.view === "approve" ? "d" : "ed"
          } successfully.`,
          timeout: 3000,
        });
        this.props.fetchAndUpdateDocMeta(this.props.docNo);
        this.props.approvalStatusCheck(JSON.parse(this.props.docID));

        // Amplitude call
        AmplitudeUtils.amplitudeLogEvent(
          this.props.view === "approve"
            ? EVENTS.EVENT_NAMES.DOCUMENT_APPROVED
            : EVENTS.EVENT_NAMES.DOCUMENT_REJECTED,
          {
            ...this.props.document,
            documentNotesCount: this.props.documentNotes.length,
          },
        );
        this.props.onClose();
      })
      .catch(() => {
        Toastr.showToastr({
          type: "success",
          message: `Oops! Couldn't ${
            this.props.view
          } document. Please try again.`,
          timeout: 3000,
        });
        this.props.onClose();
      });
  };

  render() {
    const { title, txt, btnTxt } = CONFIRMATION_TEXT[this.props.view];
    return (
      <Modal
        open
        onClose={this.props.onClose}
        closeOnOverlayClick={false}
        center>
        <div className="workflowapprovereject-wrapper">
          <div className="workflowapprovereject-header">{title}</div>
          <div className="workflowapprovereject-body">
            <p className="workflowapprovereject-txt">{txt}</p>
            <p className="workflowapprovereject-txt">
              {this.state.errMsg && (
                <div className="error-message-wrapper">
                  <span className="error-message-icon">
                    <FontAwesomeIcon icon={["far", "times-circle"]} />
                  </span>
                  {this.state.errMsg}
                </div>
              )}
            </p>
            <textarea
              className="workflowapprovereject-txtarea"
              rows="5"
              value={this.state.comment}
              onChange={e => this._onCommentChange(e)}
              data-test="workflowapprovereject-textarea"
              // eslint-disable-next-line jsx-a11y/no-autofocus
              autoFocus
            />
          </div>
          <section className="workflowapprovereject-footer">
            <Button
              className="btn-transparent"
              data-test="workflowapprovereject-cancel-button"
              onClick={this.props.onClose}>
              Cancel
            </Button>
            <Button
              data-test={`${
                this.props.view === "reject"
                  ? "workflowapprovereject-reject-button"
                  : "workflowapprovereject-approve-button"
              }`}
              className={`workflowapprovereject-${
                this.props.view === "reject" ? "reject" : "approve"
              }-btn`}
              isLoading={this.state.isSaving}
              onClick={this._onSubmitBtnClick}>
              {btnTxt}
            </Button>
          </section>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { document } = state.DocumentStore;
  const { id: docID, docNo } = document;
  const { documentNotes } = state.NotesStore;

  return { docID, docNo, document, documentNotes };
};

const mapDispatchToProps = {
  approvalStatusCheck,
  approveRejectDoc,
  fetchAndUpdateDocMeta,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WorkFlowApproveReject);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Popups/WorkFlowApproveReject/index.js